export const NEW_DISCOUNT_SELECT_ID = 'NEW_';
